import React from 'react';
import {
  Dialog as DialogHeadless,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
} from '@headlessui/react';
import { twMerge } from 'tailwind-merge';
export default function Dialog({
  open,
  setOpen,
  title,
  description,
  children,
  className,
  backdropClassName,
  containerClassName,
  panelClassName,
}) {
  return (
    <DialogHeadless
      open={open}
      onClose={setOpen}
      className={twMerge('relative z-40', className)}
    >
      <DialogBackdrop
        transition
        className={twMerge(
          'fixed inset-0 bg-gray-500/75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in',
          backdropClassName,
        )}
      />
      <div
        className={twMerge(
          'fixed inset-0 z-10 w-screen overflow-y-auto',
          containerClassName,
        )}
      >
        <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <DialogPanel
            transition
            className={twMerge(
              'relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-lg sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95',
              panelClassName,
            )}
          >
            {title && (
              <div className="sm:flex sm:items-start mb-4">
                <div className="text-center sm:text-left">
                  <DialogTitle
                    as="h3"
                    className="text-lg font-semibold text-gray-900"
                  >
                    {title}
                  </DialogTitle>
                  {description && (
                    <p className="text-sm text-gray-500">{description}</p>
                  )}
                </div>
              </div>
            )}

            {children}
          </DialogPanel>
        </div>
      </div>
    </DialogHeadless>
  );
}
